__turbopack_context__.v({
  "egress": "landing-hero-module__QNjeXq__egress",
  "instrument": "landing-hero-module__QNjeXq__instrument",
  "landedRecord": "landing-hero-module__QNjeXq__landedRecord",
  "landedSource": "landing-hero-module__QNjeXq__landedSource",
  "product": "landing-hero-module__QNjeXq__product",
  "record-landed": "landing-hero-module__QNjeXq__record-landed",
  "source-landed": "landing-hero-module__QNjeXq__source-landed",
  "stage": "landing-hero-module__QNjeXq__stage",
});
